import {
	useFormErrorNotification,
	useFormSuccessNotification,
} from "@babackapp/react-hook-forms-components/form-notifications";
import { useMutation } from "@tanstack/react-query";
import { $api } from "../generated/client";
import type { UpdateOneWorkflowDto } from "../generated/schema";
import useInvalidateShop from "./use-invalidate-shop";
import { useInvalidateWorkflowListQuery } from "./use-workflows-query";

export default function useEditWorkflow(shopId: string) {
	const successNotification = useFormSuccessNotification();
	const errorNotification = useFormErrorNotification();
	const invalidateShop = useInvalidateShop(shopId);

	const mutation = $api.useMutation(
		"patch",
		"/shops/{shopId}/workflows/{workflowId}",
	);
	const invalidateWorkflowListQuery = useInvalidateWorkflowListQuery(shopId);

	return useMutation({
		onSuccess: () => {
			invalidateShop();
			invalidateWorkflowListQuery();
			successNotification();
		},
		onError: () => {
			errorNotification();
		},
		mutationFn: async ({
			body,
			workflowId,
		}: {
			body: UpdateOneWorkflowDto;
			workflowId: string;
		}) => {
			return mutation.mutateAsync({
				params: { path: { shopId, workflowId } },
				body,
			});
		},
	});
}
